interface MAIA {
    openWindow: (url, proxyURL?) => void
    startDownload: (url) => void
    scrollTo: (top) => void
    setAppRoute: (url) => void
    setAppTitle: (title: string) => void
}

const Mergado: MAIA = {
    startDownload: (url) => {
        if(!isInIframe){
            window.open(url)
        } else {
            window["Mergado"] && typeof window["Mergado"].openWindow === "function" ? window["Mergado"].openWindow(url) : window.open(url)
        }
    },
    openWindow: (url, proxyURL = 'https://btprx.com/') => {
        if(!isInIframe){
            window.open(proxyURL+url)
        } else {
            window["Mergado"] && typeof window["Mergado"].openWindow === "function" ? window["Mergado"].openWindow(proxyURL+url) : window.open(proxyURL+url)
        }
    },
    scrollTo: (top) => {
        window["Mergado"] && window["Mergado"].scrollTo(0,top)
        window.scrollTo(0,top)
    },
    setAppRoute: (url) => window["Mergado"] && typeof window["Mergado"].setAppRoute === "function" ? window["Mergado"].setAppRoute(url) : false,
    setAppTitle: (title:string) =>  window["Mergado"] && typeof window["Mergado"].setAppTitle === "function" ? window["Mergado"].setAppTitle(title) : false,
};


export function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export const isInIframe = inIframe()

export default Mergado